export const companyInputTypeEnum = {
    companyName: "companyName",
    companyVat: "companyVat",
    dateOfCompanyEstablished: "dateOfCompanyEstablished",
    companyAddress: "companyAddress",
    companyStreetNumber: "companyStreetNumber",
    companyCity: "companyCity",
    companyPostalCode: "companyPostalCode",
    companyCountry: "companyCountry",
};
export const personalDataTypeEnum = {
    radioGender: "radioGender",
    firstName: "firstName",
    lastName: "lastName",
    birthday: "birthday",
    selectedCountry: "selectedCountry",
    radioPep: "radioPep",
}
export const BeneficialOwners = {
    pep: "pep",
    firstNameBeneficial: "firstNameBeneficial",
    lastNameBeneficial: "lastNameBeneficial",
    birthday: "birthday",
    placeOfBirthBeneficial: "placeOfBirthBeneficial",
    occupationBeneficial: "occupationBeneficial",
}
export const CompanyBankData = {
    bankIban: "bankIban",
    bankName: "bankName",
    checkedTerms: "checkedTerms"
}
export const identityUpload = {
    identityDocument: "identityDocument",
    idDocValid: "idDocValid"
}
export const reportType = {
    link: '/Reporting/v1/GenerateReportLink',
    table: '/Reporting/v1/GenerateReportTable',
    excellPdf: '/Reporting/v1/GenerateReport',
}

export const DeviceConnectivityStatusEnum = {
    Offline: 0,
    Reachable: 1,
    Online: 2
    //Unknown: 1,
    //Success: 2,
};

export const EMPTY_DATA_DASH = "---" 